import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { checkAuthorizedMiddleware } from '@adornis/bh-matching-user/checkAuthorizedMiddleware.js';
import { MatchingPermission } from '@adornis/bh-matching-user/permissions.js';
import { mongo } from '@adornis/buchungsheld-db/server/mongo.js';
import { ensureDefaultBuddyMailTemplates } from './ensure-mail-templates.js';
import { BuddyMailTemplate } from '../entities/mail-templates.js';

export const getBuddyMailTemplates = registerQuery({
  operationName: 'getBuddyMailTemplates',
  middlewares: [checkAuthorizedMiddleware(({ user }) => user.hasPermission(MatchingPermission.MANAGE_MAIL_TEMPLATES))],
  resolve:
    () =>
    async <SelSet extends BaseQLSelectionSet<BuddyMailTemplate>>(gqlFields: SelSet) => {
      await ensureDefaultBuddyMailTemplates();

      const existingBuddyMailTemplates = await mongo()
        .collection<BuddyMailTemplate>(BuddyMailTemplate._collectionName)
        .find({ _class: BuddyMailTemplate._class })
        .toArray();

      return existingBuddyMailTemplates as BuddyMailTemplate[];
    },
  type: () => [BuddyMailTemplate],
});
